
function bindCampaignBuilder() {
  $('[name="campaign[finishes_at]"]').datepicker({format: 'dd-mm-yyyy'});
  $('[name="area_id"]').selectize({
    valueField: 'id',
    searchField: 'name',
    labelField: 'name',
    load : function (query, callback) {
      if (!query.length) {
        return callback();
      }
      $.ajax({
        url: '/areas/search?query=' + encodeURIComponent(query),
        type: 'GET',
        dataType: 'JSON',
        error: function() {
          callback();
        },
        success: function(res) {
          callback(res);
        }
      });
    }
  });
  $('[name="campaign[parent_campaign_id]"]').selectize({
    valueField: 'id',
    searchField: 'internal_name',
    labelField: 'internal_name',
    // allowEmptyOption: true, <- option is broken, hence the id:0 hack below
    load : function (query, callback) {
      if (!query.length) {
        return callback();
      }
      $.ajax({
        url: '/campaigns/active/search?query=' + encodeURIComponent(query),
        type: 'GET',
        dataType: 'JSON',
        error: function() {
          callback();
        },
        success: function(res) {
          res.unshift({id: '0', internal_name: "(None)"});
          callback(res);
        }
      });
    }
  });
  $('[name="campaign[custom_layout_id]"]').selectize({
    valueField: 'id',
    searchField: 'name',
    labelField: 'name',
    load : function (query, callback) {
      if (!query.length) {
        return callback();
      }
      $.ajax({
        url: '/campaigns/custom_layouts/search?query=' + encodeURIComponent(query),
        type: 'GET',
        dataType: 'JSON',
        error: function() {
          callback();
        },
        success: function(res) {
          callback(res);
        }
      });
    }
  });


  $('body').on('change', '.js-campaign-action-toggle', function (ev) {
    if ($(this).prop('checked')) {
      $(this).parent().nextAll().show();
      $('.CodeMirror').each(function(i, el) {
        el.CodeMirror.refresh();
      });
    }
    else {
      $(this).parent().nextAll().hide();
    }
    return false;
  });

  $('#campaign_image_url').blur(function () {
    $(this).parent().parent().next().children().first().html('<img class="img-responsive" src="' + $(this).val() + '">');
  }).blur();

  $('body').on('click', '.js-commission-twilio-number', function(e) {
    e.preventDefault();
    $.ajax({
      dataType: 'json',
      url: '/twilio/commission_new_number',
      success: function(response) {
        if (typeof response.error !== 'undefined') {
          alert('There was an error commissioning a new Twilio number.');
          return;
        }
        $('#campaign_twilio_number').val(response.number);
        $('.js-commission-twilio-number').hide();
      }
    });
  });

  $(window).on('unload', function() {
    var campaignId = $('[data-campaign-id]').data('campaign-id');
    $.ajax({
      url: '/campaigns/' + campaignId + '/unlock',
      method: 'POST'
    });
  });
}


/*** EXPORTS FROM exports-loader ***/
module.exports = bindCampaignBuilder;